import React, { useEffect, useState } from 'react'
import PageHeading from '../../components/PageHeading'

// Master APIs
import GetDepartmentMaster from '../../APIs/Master/DepartmentMaster/GetDepartmentMaster'
import GetDesignationMaster from '../../APIs/Master/DesignationMaster/GetDesignationMaster'
import GetRoleMaster from '../../APIs/Master/RoleMaster/GetRoleMaster'
import GetUserType from '../../APIs/Master/UserTypeMaster/UserTypeMaster'
import SignUpApi from '../../APIs/SignUp/SignUpApi'
import GetUsers from '../../APIs/User/GetUsers'

export const UserMaster = () => {
    const clientId = window.clientId;
    const [roleList, setRoleList] = useState([])
    const [userTypeList, setUserTypeList] = useState([])
    const [designationList, setDesignationList] = useState([])
    const [departmentList, setDepartmentList] = useState([])
    const [userList, setuserList] = useState([])

    const [sendForm, setSendForm] = useState({
        name: "",
        email: "",
        mobileNo: "",
        alternateMobileNo: "",
        userName: "",
        password: "",
        roleId: 0,
        userTypeId: 0,
        userId: window.userId,
        designationId: 0,
        departmentId: 0,
        clientId: window.userId
    })

    useEffect(() => {
        getAllMasters()
    }, [])
    const getAllMasters = async () => {

        const results = await Promise.allSettled([
            GetRoleMaster(clientId),
            GetUserType(clientId),
            GetDesignationMaster(clientId),
            GetDepartmentMaster(clientId)
        ])

        const [
            roleRes,
            userTypeRes,
            desigRes,
            deptRes
        ] = results

        if (roleRes.status === "fulfilled" && roleRes.value?.status === 1) {
            setRoleList(roleRes.value.responseValue)
        }

        if (userTypeRes.status === "fulfilled" && userTypeRes.value?.status === 1) {
            setUserTypeList(userTypeRes.value.responseValue)
        }

        if (desigRes.status === "fulfilled" && desigRes.value?.status === 1) {
            setDesignationList(desigRes.value.responseValue)
        }

        if (deptRes.status === "fulfilled" && deptRes.value?.status === 1) {
            setDepartmentList(deptRes.value.responseValue)
        }
    }

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target

        setSendForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }))
    }

    const handleSave = async () => {

        const payload = {
            ...sendForm,
            roleId: Number(sendForm.roleId),
            userTypeId: Number(sendForm.userTypeId),
            designationId: Number(sendForm.designationId),
            departmentId: Number(sendForm.departmentId),
            clientId: Number(sendForm.clientId),
            userId: Number(sendForm.userId)
        }

        console.log("User Save Payload :", payload)
        const response = await SignUpApi(payload);
        // await SaveUser(payload)
    }
    const getuserslist = async () => {
        const response = await GetUsers(clientId);
        if(response.status ===1){
            setuserList(response.responseValue)
        }
    }
    useEffect(() => {
        getuserslist();
    }, [])
    return (
        <div className='row'>
            <PageHeading pagename="User Master" />

            <div className='row container-fluid landformconatiner p-4'>

                {/* Name */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Name</label> <br/>
                    <input
                        className='form-input-box'
                        name="name"
                        value={sendForm.name}
                        onChange={handleChange}
                    />
                </div>

                {/* Email */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Email</label><br/>
                    <input
                        className='form-input-box'
                        name="email"
                        value={sendForm.email}
                        onChange={handleChange}
                    />
                </div>

                {/* Mobile */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Mobile No</label><br/>
                    <input
                        className='form-input-box'
                        name="mobileNo"
                        value={sendForm.mobileNo}
                        onChange={handleChange}
                    />
                </div>

                {/* Alternate Mobile */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Alternate Mobile No</label><br/>

                    <input
                        className='form-input-box'
                        name="alternateMobileNo"
                        value={sendForm.alternateMobileNo}
                        onChange={handleChange}
                    />
                </div>

                {/* Username */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>User Name</label><br/>
                    <input
                        className='form-input-box'
                        name="userName"
                        value={sendForm.userName}
                        onChange={handleChange}
                    />
                </div>

                {/* Password */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Password</label><br/>
                    <input
                        type="password"
                        className='form-input-box'
                        name="password"
                        value={sendForm.password}
                        onChange={handleChange}
                    />
                </div>

                {/* Role */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Role</label><br/>
                    <select
                        className='form-input-box'
                        name="roleId"
                        value={sendForm.roleId}
                        onChange={handleChange}
                    >
                        <option value="0">--Select Role--</option>
                        {
                            roleList?.map(val => (
                                <option key={val.id} value={val.id}>
                                    {val.roleTitle}
                                </option>
                            ))
                        }
                    </select>
                </div>

                {/* User Type */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>User Type</label><br/>
                    <select
                        className='form-input-box'
                        name="userTypeId"
                        value={sendForm.userTypeId}
                        onChange={handleChange}
                    >
                        <option value="0">--Select User Type--</option>
                        {
                            userTypeList?.map(val => (
                                <option key={val.id} value={val.id}>
                                    {val.userType}
                                </option>
                            ))
                        }
                    </select>
                </div>

                {/* Designation */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Designation</label><br/>
                    <select
                        className='form-input-box'
                        name="designationId"
                        value={sendForm.designationId}
                        onChange={handleChange}
                    >
                        <option value="0">--Select Designation--</option>
                        {
                            designationList?.map(val => (
                                <option key={val.id} value={val.id}>
                                    {val.designationName}
                                </option>
                            ))
                        }
                    </select>
                </div>

                {/* Department */}
                <div className='col-md-4 mb-3'>
                    <label className='form-label'>Department</label><br/>
                    <select
                        className='form-input-box'
                        name="departmentId"
                        value={sendForm.departmentId}
                        onChange={handleChange}
                    >
                        <option value="0">--Select Department--</option>
                        {
                            departmentList?.map(val => (
                                <option key={val.id} value={val.id}>
                                    {val.departmentName}
                                </option>
                            ))
                        }
                    </select>
                </div>

                {/* Save */}
                <div className='col-12 mt-3'>
                    <button className='btn btn-primary' onClick={handleSave}>
                        Save
                    </button>
                </div>

            </div>
            <div className="pt-4">
                <table className="table">
                    <thead>
                        <tr className="table-head">

                        <th>Name</th>
                        <th>Email</th>
                        </tr>
                    </thead>
                    <tbody style={{width:"100%"}}>
                        {userList&&userList.map((val)=>{
                            return(
                                <tr>
                                    <td>
                                        {val.name}
                                    </td>
                                    <td>
                                        {val.email}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
